export default "﻿<div style=\"\" class=\"calendar\" data-extension-name=\"KBB\">\n\n</div>"